import React, { useContext, useEffect, useState } from "react";
import axios from "axios";
import InfiniteScroll from "react-infinite-scroll-component";
import { Loader } from "react-feather";
import "./App.css";
import NewsList from "./components/NewsList";
import Header from "./components/Header";
import ThemeContext from "./context/ThemeContext";
import { AppTheme } from "./context/ThemeContext";
import { Router } from "@reach/router";
import Detail from "./components/Detail";

const Main = ({ stories, fetchStories, loadMore, hasMore, number, path }) => {
  const theme = useContext(ThemeContext)[0];
  const currentTheme = AppTheme[theme];
  document.body.style.backgroundColor = currentTheme.background;
  document.body.style.color = currentTheme.foreground;

  return (
    <div>
      <Header fetchStories={key => fetchStories(key)} path={path} />
      {stories ? (
        <InfiniteScroll
          dataLength={number}
          hasMore={hasMore}
          next={() => loadMore()}
          loader={
            <div className="loading">
              <Loader />
            </div>
          }
        >
          <NewsList stories={stories.slice(0, number)} />
        </InfiniteScroll>
      ) : null}
    </div>
  );
};

function App() {
  const d = new Date();
  const hour = d.getHours();

  const theme = useState(hour > 8 && hour < 20 ? "light" : "dark");
  const [stories, setStories] = useState([]);
  const [number, setNumber] = useState(20);
  const [hasMore, setHasMore] = useState(true);

  const loadMore = () => {
    if (number > stories.length) {
      setHasMore(false);
    }

    setTimeout(() => {
      setNumber(number + 20);
    }, 1000);
  };

  const API_URL = "https://hacker-news.firebaseio.com/v0/";
  const fetchStories = async key => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    try {
      const response = await axios.get(`${API_URL}${key}stories.json`);
      setStories(response.data);
    } catch (e) {
      console.log(e);
    }
  };

  useEffect(() => {
    fetchStories("top");
  }, []);

  useEffect(() => {
    setNumber(20);
  }, [stories]);

  return (
    <ThemeContext.Provider value={theme}>
      <div className="App">
        <Router>
          <Main
            stories={stories}
            loadMore={() => loadMore()}
            number={number}
            hasMore={hasMore}
            fetchStories={key => fetchStories(key)}
            path="/"
          />
          <Detail path="/:id" />
        </Router>
      </div>
    </ThemeContext.Provider>
  );
}

export default App;
